import ReactOnRails from 'react-on-rails';
import DogRescues from '../../bundles/DogRescues/components/DogRescues.client.jsx';

ReactOnRails.register({DogRescues});
